import request from '@/utils/request'
import API from '@/api/index.js'

// 登录方法
export function dwUserInfo () {
  return request({
    url: API.curUserInfo,
    method: 'get'
  })
}

// 退出方法
export function dwUserPwd (curpwd, pwd) {
  const params = {
    curpwd,
    pwd
  }
  return request({
    url: API.curUserPwdUpdate,
    method: 'post',
    params
  })
}

// 绑定手机号
export function dwUserBindPhone (params) {
  return request({
    url: '/api/dwsurvey/app/user/up-bind-phone.do',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/dw-user.js